import React, { useState, useEffect } from 'react';
import ActiveGroupContext from 'contexts/active_group/context';
import { ACTIVE_GROUP_COOKIE_NAME } from 'constants';
import { useSession } from 'hooks/use_context';
import sessionStore from 'services/session_store';

export const setActiveGroupCookie = (groupId) => {
  sessionStore.set(ACTIVE_GROUP_COOKIE_NAME, groupId);
};

export const deleteActiveGroupCookie = () => {
  sessionStore.delete(ACTIVE_GROUP_COOKIE_NAME);
};

const ActiveGroupProvider = ({ children }) => {
  const { accessibleGroups, currentGroup } = useSession();
  const [activeGroup, setActiveGroup] = useState(currentGroup);
  useEffect(() => {
    if (!currentGroup || !currentGroup.id) {
      return;
    }
    setActiveGroupCookie(currentGroup.id);
  }, []);

  const setNewActiveGroup = (group) => {
    setActiveGroup(group);
    setActiveGroupCookie(group.id);
  };

  return (
    <ActiveGroupContext.Provider
      value={{
        setActiveGroup: setNewActiveGroup,
        accessibleGroups,
        activeGroup,
      }}
    >
      {children}
    </ActiveGroupContext.Provider>
  );
};

export default ActiveGroupProvider;
